import axios from "axios";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import getUrl from "../../../../constants/urlConst";


export function ApiLuggage() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: getUrl(),
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  return {
    addLuggage: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "luggage/add", model);
        return response.data;
      } catch (error) {
        console.error("Error adding luggage:", error);
        throw error;
      }
    },

    updateLuggage: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "luggage/update", model);
        return response.data;
      } catch (error) {
        console.error("Error adding luggage:", error);
        throw error;
      }
    },

    updateLuggageStatus: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "luggage/update-status", model);
        return response.data;
      } catch (error) {
        console.error("Error adding luggage:", error);
        throw error;
      }
    },

    getLuggage: async () => {
      try {
        const response = await authAxios.get(getUrl() + "luggage/list");
        return response.data;
      } catch (error) {
        console.error("Error fetching luggages:", error);
        throw error;
      }
    },

    getLuggages: async (pageIndex = 0, pageSize = 20, search = "", sortBy = "updated", sortDir = "DESC") => {
      try {
        const response = await authAxios.get(getUrl() + "luggages/list", {
          params: { pageIndex, pageSize, search, sortBy, sortDir },
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching luggages:", error);
        throw error;
      }
    },

    getLuggageById: async (id) => {
      try {
        const response = await authAxios.get(getUrl() + `luggageById/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching luggages:", error);
        throw error;
      }
    },

    getCarrierLuggage: async (carrierId) => {
      try {
        const response = await authAxios.get(getUrl() + `luggage/${carrierId}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching luggages:", error);
        throw error;
      }
    },

    deleteLuggage: async (luggageId) => {
      try {
        const response = await authAxios.delete(getUrl() + `luggage/${luggageId}`);
        return response.data;
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }
    },

    bulkDeleteLuggages: async (ids) => {
      const response = await authAxios.delete(getUrl() + "luggage/bulk", {
        data: { ids },
      });
      return response.data;
    },
  };
}
